import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";

export default function ClientResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (password.length < 6) { setErr("Mot de passe trop court (min. 6 caractères)"); return; }
    if (password !== confirm) { setErr("Les deux mots de passe ne correspondent pas"); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
    } catch (e2) {
      setErr(e2?.response?.data?.detail || "Lien invalide ou expiré. Refais une demande.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="reset-page" className="min-h-screen flex items-center justify-center p-4 bg-cream">
      <div className="w-full max-w-md rounded-[24px] bg-white shadow-[0_40px_100px_-30px_rgba(0,0,0,0.25)] border border-border/60 p-7 sm:p-8">
        <h1 className="font-display text-2xl font-light tracking-tight">Nouveau mot de passe</h1>
        {!token && (
          <p data-testid="reset-no-token" className="mt-3 text-sm text-destructive">Lien invalide : aucun jeton fourni.</p>
        )}
        {done ? (
          <div className="mt-4">
            <p data-testid="reset-success" className="text-sm text-sage">Mot de passe mis à jour. Tu peux te connecter.</p>
            <button data-testid="reset-goto-login" onClick={() => navigate("/")}
              className="mt-5 w-full rounded-full bg-obsidian text-white px-6 py-3 text-sm font-medium hover:bg-obsidian/90 transition-colors">
              Aller à la connexion
            </button>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-5 space-y-3">
            <input data-testid="reset-password-input" type="password" required placeholder="Nouveau mot de passe (min. 6 caractères)"
              value={password} onChange={(e) => setPassword(e.target.value)} disabled={!token}
              className="w-full rounded-xl border border-border bg-white px-4 py-3 text-sm outline-none focus:border-sage focus:ring-2 focus:ring-sage/20 transition-[border-color,box-shadow]" />
            <input data-testid="reset-confirm-input" type="password" required placeholder="Confirme le mot de passe"
              value={confirm} onChange={(e) => setConfirm(e.target.value)} disabled={!token}
              className="w-full rounded-xl border border-border bg-white px-4 py-3 text-sm outline-none focus:border-sage focus:ring-2 focus:ring-sage/20 transition-[border-color,box-shadow]" />
            {err && <p data-testid="reset-error" className="text-sm text-destructive">{err}</p>}
            <button data-testid="reset-submit" type="submit" disabled={busy || !token}
              className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-obsidian text-white px-6 py-3 text-sm font-medium hover:bg-obsidian/90 transition-colors disabled:opacity-60">
              {busy && <Loader2 size={16} className="animate-spin" />}
              Mettre à jour mon mot de passe
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
